import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { getTestId } from '@airtel/air-design-system';
import { View } from 'react-native';
import { getComparePlanListStyles } from './CompareBenefitStyles';
import ComparePlanBenefitItem from '../compare-benefit-item/CompareBenefitItem';
import { getRenderListData } from '../../ComparisonViewCardWidgetUtils';
import CompareListFooter from '../compare-list-footer/CompareListFooter';
var ComparePlanBenefitList = props => {
  var _props$data = props.data,
    data = _props$data === void 0 ? [] : _props$data,
    id = props.id,
    _props$expandCtaData = props.expandCtaData,
    expandCtaData = _props$expandCtaData === void 0 ? {} : _props$expandCtaData,
    _props$showExpandCta = props.showExpandCta,
    showExpandCta = _props$showExpandCta === void 0 ? false : _props$showExpandCta,
    _props$isTableView = props.isTableView,
    isTableView = _props$isTableView === void 0 ? false : _props$isTableView,
    _props$showBottomLeft = props.showBottomLeftRadius,
    showBottomLeftRadius = _props$showBottomLeft === void 0 ? false : _props$showBottomLeft,
    _props$showBottomRigh = props.showBottomRightRadius,
    showBottomRightRadius = _props$showBottomRigh === void 0 ? false : _props$showBottomRigh,
    onFooterCtaPressMetaData = props.onFooterCtaPressMetaData,
    onUserAction = props.onUserAction,
    style = props.style,
    theme = props.theme,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'ComparePlanBenefitList' : _props$testID;
  var _expandCtaData$initia = expandCtaData.initialItemCount,
    initialItemCount = _expandCtaData$initia === void 0 ? 8 : _expandCtaData$initia;
  var _useState = useState(false),
    showFullList = _useState[0],
    setShowFullList = _useState[1];
  var comparePlanListStyles = getComparePlanListStyles(isTableView, showBottomLeftRadius, showBottomRightRadius);
  var renderedData = getRenderListData(showFullList, showExpandCta, data, initialItemCount);
  var toggleShowFullList = () => {
    setShowFullList(!showFullList);
    onFooterCtaPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, onFooterCtaPressMetaData)));
  };
  var renderListItem = _ref => {
    var item = _ref.item,
      index = _ref.index;
    return _jsx(ComparePlanBenefitItem, Object.assign({
      id: 'benefitListItem',
      isTableView: isTableView,
      onUserAction: onUserAction
    }, item, {
      showDivider: index !== renderedData.length - 1 && (item === null || item === void 0 ? void 0 : item.showDivider)
    }, getTestId(testID + '_benefitItem', index === null || index === void 0 ? void 0 : index.toString()), {
      theme: theme
    }), "plan-benefit-item-" + index);
  };
  return _jsx(_Fragment, {
    children: (renderedData === null || renderedData === void 0 ? void 0 : renderedData.length) > 0 && _jsxs(View, Object.assign({}, getTestId(testID, 'list'), {
      style: [comparePlanListStyles.listContainer, style]
    }, {
      children: [renderedData === null || renderedData === void 0 ? void 0 : renderedData.map((item, index) => renderListItem({
        item,
        index
      })), _jsx(CompareListFooter, Object.assign({
        itemsCount: data === null || data === void 0 ? void 0 : data.length,
        expandCtaData: expandCtaData,
        toggleShowFullList: toggleShowFullList,
        showFullList: showFullList,
        showExpandCta: showExpandCta
      }, getTestId(testID, 'compare_footer')))]
    }))
  });
};
export default ComparePlanBenefitList;